module.exports = __webpack_public_path__ + "static/5.e4fb6b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MasterTheses/5.png
// module id = 827
// module chunks = 39236203315009 172526442442348